window.LouvreCalculator = {
  calculate: function (layout, input) {
    if (layout === 'louvre_horizontal_screening') {
      return this.calculateHorizontalScreening(input);
    }
    if (layout === 'louvre_vertical_screening') {
      return this.calculateVerticalScreening(input);
    }
    if (layout === 'louvre_horizontal_shutter') {
      return this.calculateHorizontalShutter(input);
    }
    if (layout === 'louvre_vertical_shutter') {
      return this.calculateVerticalShutter(input);
    }
    if (layout === 'louvre_horizontal_gate') {
      return this.calculateHorizontalGate(input);
    }
    if (layout === 'louvre_vertical_gate') {
      return this.calculateVerticalGate(input);
    }
  },

  calculateHorizontalScreening: function (input) {
    const panels = Array.isArray(input.panels)
      ? input.panels
      : [
          {
            width: input.panelWidth / input.panelCount,
            height: input.panelHeight,
            quantity: input.panelCount
          }
      ];
    const louvreStyle = input.gap;
    //Louvre
    const louvrePieces = [];
    panels.forEach(function (panel) {
      const louvreUsableHeight = panel.height - 130;
      const louvreRows = Math.floor(louvreUsableHeight / 50);
      for (let i = 0; i < louvreRows * panel.quantity; i++) {
        louvrePieces.push(panel.width);
      }
    });
    const louvreRawMaterial = window.CutOptimizer.optimize(louvrePieces, 5800);
    //Slat
    const slatPieces = [];
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity * 2; i++) {
        slatPieces.push(panel.width);
      }
    });
    const slatRawMaterial = window.CutOptimizer.optimize(slatPieces, 5800);
    //Post
    const postPieces = [];
    let postQuantity = 0;
    panels.forEach(function (panel) {
      if (panel.addPost) {
        const groupPostQuantity = panel.quantity + 1;
        postQuantity += groupPostQuantity;
        for (let i = 0; i < groupPostQuantity; i++) {
          postPieces.push(panel.height);
        }
      }
    });
    let postRawMaterial = 0;
    if (postPieces.length > 0) {
      postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    }
    //Concealed Fixing Rail
    const concealedFixingRailPieces = [];
    let concealedFixingRailQuantity = 0;
    panels.forEach(function (panel) {
      const groupRailQuantity = panel.quantity * 2;
      concealedFixingRailQuantity += groupRailQuantity;
      for (let i = 0; i < panel.quantity; i++) {
        concealedFixingRailPieces.push(panel.height);
        concealedFixingRailPieces.push(panel.height);
      }
    });
    const concealedFixingRailRawMaterial = window.CutOptimizer.optimize(concealedFixingRailPieces, 5800);
    //Concealed Fixing Cover
    const concealedFixingCoverPieces = [];
    let concealedFixingCoverQuantity = 0;
    panels.forEach(function (panel) {
      const groupCoverQuantity = panel.quantity * 2;
      concealedFixingCoverQuantity += groupCoverQuantity;
      for (let i = 0; i < panel.quantity; i++) {
        concealedFixingCoverPieces.push(panel.height);
        concealedFixingCoverPieces.push(panel.height);
      }
    });
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //Louvre Bracket Pair
    let louvreBracketPairQuantity = 0;
    panels.forEach(function (panel) {
      const louvreUsableHeight = panel.height - 130;
      const louvreRows = Math.floor(louvreUsableHeight / 50);
      louvreBracketPairQuantity += louvreRows * panel.quantity;
    });
    //Post Cap
    const postCapQuantity = postQuantity;
    //Channel Cap
    let channelCapQuantity = 0;
    panels.forEach(function (panel) {
      channelCapQuantity += panel.quantity * 2;
    });
    //Screw
    let screwQuantity = 0;
    panels.forEach(function (panel) {
      const louvreUsableHeight = panel.height - 130;
      const louvreRows = Math.floor(louvreUsableHeight / 50);
      const screwMultiplier = panel.addPost
        ? 4
        : 2;

      const currentPanelScrewQuantity = (louvreRows + 2) * screwMultiplier * panel.quantity;
      panel.screwQuantity = currentPanelScrewQuantity;
      screwQuantity += currentPanelScrewQuantity;
    });
    const screwPackQuantity = Math.ceil(screwQuantity / 100);

    //Breakdown Detail
    const panelDetails = [];
    panels.forEach(function (panel) {
      const louvreUsableHeight = panel.height - 130;
      const louvreRows = Math.floor(louvreUsableHeight / 50);
      const railQuantityPerPanel = 2;
      panelDetails.push(
        window.FencingDetailBuilder.createHorizontalLouvreScreening(
          panel,
          louvreStyle,
          louvreRows,
          railQuantityPerPanel,
          panel.screwQuantity,
        )
      );
    });

    const materialResults = [
      {name:'Louvre', qty: louvreRawMaterial },
      {name:'Slat', qty: slatRawMaterial },
      {name:'Concealed Fixing Rail', qty: concealedFixingRailRawMaterial },
      {name:'Concealed Fixing Cover', qty: concealedFixingCoverRawMaterial },
      {name:'Louvre Bracket Pair', qty: louvreBracketPairQuantity },
      {name:'Channel Cap', qty: channelCapQuantity },
      {name:'Screw', qty: screwPackQuantity},
    ];
    if (postRawMaterial > 0) {
      materialResults.splice(2, 0,
        {name:'Post', qty: postRawMaterial }
      );
    }
    if (postCapQuantity > 0) {
      materialResults.push(
        {name:'Post Cap', qty: postCapQuantity }
      );
    }
    materialResults.details = panelDetails;

    return materialResults;
  },

  calculateVerticalScreening: function (input) {
    const panels = Array.isArray(input.panels)
      ? input.panels
      : [
          {
            width: input.panelWidth / input.panelCount,
            height: input.panelHeight,
            quantity: input.panelCount
          }
        ];
    const louvreStyle = input.gap;
    //Louvre
    const louvrePieces = [];
    panels.forEach(function (panel) {
      const louvreUsableWidth = panel.width - 130;
      const louvreColumns = Math.floor(louvreUsableWidth / 50);
      for (let i = 0; i < louvreColumns * panel.quantity; i++) {
        louvrePieces.push(panel.height);
      }
    });
    const louvreRawMaterial = window.CutOptimizer.optimize(louvrePieces, 5800);
    //Slat
    const slatPieces = [];
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity * 2; i++) {
        slatPieces.push(panel.height);
      }
    });
    const slatRawMaterial = window.CutOptimizer.optimize(slatPieces, 5800);
    //Post
    const postPieces = [];
    let postQuantity = 0;
    panels.forEach(function (panel) {
      if (panel.addPost) {
        const verticalPostQuantity = panel.quantity + 1;
        postQuantity += verticalPostQuantity;
        for (let i = 0; i < verticalPostQuantity; i++) {
          postPieces.push(panel.height);
        }
        for (let i = 0; i < panel.quantity * 2; i++) {
          postPieces.push(panel.width);
        }
      }
    });
    let postRawMaterial = 0;
    if (postPieces.length > 0) {
      postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    }
    //Concealed Fixing Rail
    const concealedFixingRailPieces = [];
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity; i++) {
        concealedFixingRailPieces.push(panel.height);
        concealedFixingRailPieces.push(panel.height);
        concealedFixingRailPieces.push(panel.width);
        concealedFixingRailPieces.push(panel.width);
      }
    });
    const concealedFixingRailRawMaterial = window.CutOptimizer.optimize(concealedFixingRailPieces, 5800);
    //Concealed Fixing Cover
    const concealedFixingCoverPieces = [];
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity; i++) {
        concealedFixingCoverPieces.push(panel.height);
        concealedFixingCoverPieces.push(panel.height);
        concealedFixingCoverPieces.push(panel.width);
        concealedFixingCoverPieces.push(panel.width);
      }
    });
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //Louvre Bracket Pair
    let louvreBracketPairQuantity = 0;
    panels.forEach(function (panel) {
      const louvreUsableWidth = panel.width - 130;
      const louvreColumns = Math.floor(louvreUsableWidth / 50);
      louvreBracketPairQuantity += louvreColumns * panel.quantity;
    });
    //Post Cap
    const postCapQuantity = postQuantity;
    //Screw
    let screwQuantity = 0;
    panels.forEach(function (panel) {
      const louvreUsableWidth = panel.width - 130;
      const louvreColumns = Math.floor(louvreUsableWidth / 50);
      const verticalFixingPoints = Math.floor(panel.height / 50);

      const screwMultiplier = panel.addPost
        ? 4
        : 2;
      const louvreScrewQuantity = (louvreColumns + 2) * screwMultiplier;
      const frameScrewQuantity = verticalFixingPoints * screwMultiplier;
      const currentPanelScrewQuantity = (louvreScrewQuantity + frameScrewQuantity) * panel.quantity;
      panel.screwQuantity = currentPanelScrewQuantity;
      screwQuantity += currentPanelScrewQuantity;
    });
    const screwPackQuantity = Math.ceil(screwQuantity / 100);
    //Breakdown Detail
    const panelDetails = [];
    panels.forEach(function (panel) {
      const louvreUsableWidth = panel.width -130;
      const louvreColumns = Math.floor(louvreUsableWidth / 50);
      panelDetails.push(
        window.FencingDetailBuilder.createVerticalLouvreScreening(
          panel,
          louvreStyle,
          louvreColumns,
          panel.screwQuantity
        )
      );
    });

    const materialResults = [
      {name:'Louvre', qty: louvreRawMaterial },
      {name:'Slat', qty: slatRawMaterial },
      {name:'Concealed Fixing Rail', qty: concealedFixingRailRawMaterial },
      {name:'Concealed Fixing Cover', qty: concealedFixingCoverRawMaterial },
      {name:'Louvre Bracket Pair', qty: louvreBracketPairQuantity },
      {name:'Screw', qty: screwPackQuantity }
    ];
    if (postRawMaterial > 0) {
      materialResults.splice(2, 0,
        {name:'Post', qty: postRawMaterial }
      );
    }
    if (postCapQuantity > 0) {
      materialResults.push(
        {name:'Post Cap', qty: postCapQuantity }
      );
    }
    materialResults.details = panelDetails;

    return materialResults;
  },

  calculateHorizontalShutter: function (input) {
    const panels = Array.isArray(input.panels)
      ? input.panels
      : [
          {
            width: input.panelWidth / input.panelCount,
            height: input.panelHeight,
            quantity: input.panelCount
          }
        ];
    const louvreStyle = input.gap;
    //Louvre
    const louvrePieces = [];
    panels.forEach(function (panel) {
      const slatQuantityPerPanel = panel.height > 4000 ? 3 : 2;
      const louvreUsableHeight = panel.height - (65 * slatQuantityPerPanel);
      const louvreRows = Math.floor(louvreUsableHeight / 65);
      for (let i = 0; i < louvreRows * panel.quantity; i++) {
        louvrePieces.push(panel.width);
      }
    });
    const louvreRawMaterial = window.CutOptimizer.optimize(louvrePieces, 5800);
    //Slat
    const slatPieces = [];
    panels.forEach(function (panel) {
      const slatQuantityPerPanel = panel.height > 4000 ? 3 : 2;
      for (let i = 0; i < slatQuantityPerPanel * panel.quantity; i++) {
        slatPieces.push (panel.width);
      }
    });
    const slatRawMaterial = window.CutOptimizer.optimize(slatPieces, 5800);
    //Post
    const postPieces = [];
    let postQuantity = 0;
    panels.forEach(function (panel) {
      if (panel.addPost) {
        const groupPostQuantity = panel.quantity + 1;
        postQuantity += groupPostQuantity;
        for (let i = 0; i < groupPostQuantity; i++) {
          postPieces.push(panel.height);
        }
      }
    });
    let postRawMaterial = 0;
    if (postPieces.length > 0) {
      postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    }
    //Concealed Fixing Rail
    const concealedFixingRailPieces = [];
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity * 2; i++) {
        concealedFixingRailPieces.push(panel.height);
      }
    });
    const concealedFixingRailRawMaterial = window.CutOptimizer.optimize(concealedFixingRailPieces, 5800);
    //Concealed Fixing Cover
    const concealedFixingCoverPieces = [];
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity * 2; i++) {
        concealedFixingCoverPieces.push(panel.height);
      }
    });
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //Channel Infill Hollow
    const channelInfillHollowPieces = [];
    panels.forEach(function (panel) {
      if (panel.height > 4000) {
        const hollowTotalHeight = panel.height - (65 * 3);
        const hollowSectionHeight = hollowTotalHeight / 2;
        for (let i = 0; i < panel.quantity * 4; i++) {
          channelInfillHollowPieces.push(hollowSectionHeight);
        }
      } else {
        const hollowHeight = panel.height - (65 * 2);
        for (let i = 0; i < panel.quantity * 2; i++) {
          channelInfillHollowPieces.push(hollowHeight);
        }
      }
    });
    const channelInfillHollowRawMaterial = window.CutOptimizer.optimize(channelInfillHollowPieces, 3980);
    //Adjustable Louvre Handle
    const adjustableLouvreHandleRawMaterial = channelInfillHollowRawMaterial;
    // Adjustable Louvre Bracket Pair
    let adjustableLouvreBracketQuantity = 0;
    panels.forEach(function (panel) { 
      const slatQuantityPerPanel = panel.height > 4000 ? 3 : 2;
      const louvreUsableHeight = panel.height - (65 * slatQuantityPerPanel);
      const louvreRows = Math.floor(louvreUsableHeight / 65);
      adjustableLouvreBracketQuantity += louvreRows * panel.quantity;
    });
    //Post Cap
    const postCapQuantity = postQuantity;
    //Channel Cap
    let channelCapQuantity = 0;
    panels.forEach(function (panel) {
      channelCapQuantity += panel.quantity * 2;
    });
    //Screw
    let screwQuantity = 0;
    panels.forEach(function (panel) {
      const fixingPoints = Math.floor(panel.height / 65);
      const screwMultiplier = panel.addPost
        ? 4
        : 2
      const currentPanelScrewQuantity = fixingPoints * screwMultiplier * panel.quantity;
      panel.screwQuantity = currentPanelScrewQuantity;
      screwQuantity += currentPanelScrewQuantity;
    });
    const screwPackQuantity = Math.ceil(screwQuantity / 100);
    //Breakdown Detail
    const panelDetails = [];
    panels.forEach(function (panel) {
      const slatQuantityPerPanel = panel.height > 4000 ? 3 : 2;
      const louvreUsableHeight = panel.height - (65 * slatQuantityPerPanel);
      const louvreRows = Math.floor(louvreUsableHeight / 65);
      const railQuantityPerPanel = 2;

      panelDetails.push(
        window.FencingDetailBuilder.createHorizontalShutter(
          panel,
          louvreStyle,
          louvreRows,
          railQuantityPerPanel,
          screwQuantity,
        )
      );
    });

    const materialResults = [
      {name:'Louvre', qty: louvreRawMaterial },
      {name:'Slat', qty: slatRawMaterial },
      {name:'Concealed Fixing Rail', qty: concealedFixingRailRawMaterial },
      {name:'Concealed Fixing Cover', qty: concealedFixingCoverRawMaterial },
      {name:'Channel Infill Hollow', qty: channelInfillHollowRawMaterial },
      {name:'Adjustable Louvre Handle', qty: adjustableLouvreHandleRawMaterial },
      {name:'Adjustable Louvre Bracket Pair', qty: adjustableLouvreBracketQuantity },
      {name:'Channel Cap', qty: channelCapQuantity },
      {name:'Screw', qty: screwPackQuantity}
    ];
    if (postRawMaterial > 0) {
      materialResults.splice(2, 0,
        {name:'Post', qty: postRawMaterial }
      );
    }
    if (postCapQuantity > 0) {
      materialResults.push(
        {name:'Post Cap', qty: postCapQuantity }
      );
    }
    materialResults.details = panelDetails;

    return materialResults;
  },

  calculateVerticalShutter: function (input){
    const panels = Array.isArray(input.panels)
      ? input.panels
      : [ 
          {
            width: input.panelWidth / input.panelCount,
            height: input.panelHeight,
            quantity: input.panelCount
          }
        ];
    const louvreStyle = input.gap;
    //Louvre
    const louvrePieces = [];
    panels.forEach(function (panel) {
      const louvreUsableWidth = panel.width - (65 * 2);
      const louvreColumns = Math.floor(louvreUsableWidth / 65);
      for (let i = 0; i < louvreColumns * panel.quantity; i++) {
        louvrePieces.push(panel.height);
      }
    });
    const louvreRawMaterial = window.CutOptimizer.optimize(louvrePieces, 5800);
    //Slat
    const slatPieces = [];
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity * 2; i++) {
        slatPieces.push(panel.height);
      }
    });
    const slatRawMaterial = window.CutOptimizer.optimize(slatPieces, 5800);
    //Post
    const postPieces = [];
    let postQuantity = 0;
    panels.forEach(function (panel) {
      if (panel.addPost) {
        const verticalPostQuantity = panel.quantity + 1;
        postQuantity += verticalPostQuantity;
        for (let i = 0; i < verticalPostQuantity; i++) {
          postPieces.push(panel.height);
        }
        for (let i = 0; i < panel.quantity * 2; i++) {
          postPieces.push(panel.width);
        }
      }
    });
    let postRawMaterial = 0;
    if (postPieces.length > 0) {
      postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    }
    //concealed Fixing Rail
    const concealedFixingRailPieces = [];
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity; i++) {
        concealedFixingRailPieces.push(panel.height);
        concealedFixingRailPieces.push(panel.height);
        concealedFixingRailPieces.push(panel.width);
        concealedFixingRailPieces.push(panel.width);
      }
    });
    const concealedFixingRailRawMaterial = window.CutOptimizer.optimize(concealedFixingRailPieces, 5800);
    //concealed Fixing Cover
    const concealedFixingCoverPieces = [];
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity; i++) {
        concealedFixingCoverPieces.push(panel.height);
        concealedFixingCoverPieces.push(panel.height);
        concealedFixingCoverPieces.push(panel.width);
        concealedFixingCoverPieces.push(panel.width);
      }
    });
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //Channel Infill Hollow
    const channelInfillHollowPieces = [];
    panels.forEach(function (panel) {
      if (panel.width > 4000) {
        const hollowTotalWidth = panel.width - (65 * 3);
        const hollowSectionWidth = hollowTotalWidth / 2;
        for (let i = 0; i < panel.quantity * 4; i++) {
          channelInfillHollowPieces.push(hollowSectionWidth);
        }
      } else {
        const hollowWidth = panel.width - (65 * 2);
        for (let i = 0; i < panel.quantity * 2; i++) {
          channelInfillHollowPieces.push(hollowWidth);
        }
      }
    });
    const channelInfillHollowRawMaterial = window.CutOptimizer.optimize(channelInfillHollowPieces, 3980);
    // Adjustable Louvre Handle
    const adjustableLouvreHandleRawMaterial = channelInfillHollowRawMaterial;
    // Adjustable Louvre Bracket Pair
    let adjustableLouvreBracketQuantity = 0;
    panels.forEach(function (panel) {
      const louvreUsableWidth =panel.width - (65 * 2);
      const louvreColumns = Math.floor(louvreUsableWidth / 65);
      adjustableLouvreBracketQuantity += louvreColumns * panel.quantity;
    });
    //Post Cap
    const postCapQuantity = postQuantity;
    //Screw 
    let screwQuantity = 0;
    panels.forEach(function (panel) {
      const horizontalFixingPoints = Math.floor(panel.width / 65);
      const verticalFixingPoints = Math.floor(panel.height / 65);

      const screwMultiplier = 
        panel.addPost || panel.addFrame
          ? 4
          : 2;
      const currentPanelScrewQuantity = ( (horizontalFixingPoints * screwMultiplier) + (verticalFixingPoints * screwMultiplier)) * panel.quantity;
      panel.screwQuantity = currentPanelScrewQuantity;
      screwQuantity += currentPanelScrewQuantity;
    });
    const screwPackQuantity = Math.ceil(screwQuantity / 100);
    //Breakdown Detail
    const panelDetails = [];
    panels.forEach(function (panel) {
      const louvreUsableWidth = panel.width - (65 * 2);
      const louvreColumns = Math.floor(louvreUsableWidth / 65);
      panelDetails.push(
        window.FencingDetailBuilder.createVerticalShutter(
          panel,
          louvreStyle,
          louvreColumns,
          panel.screwQuantity
        )
      );
    });

    const materialResults = [
      {name:'Louvre', qty: louvreRawMaterial },
      {name:'Slat', qty: slatRawMaterial },
      {name:'Concealed Fixing Rail', qty: concealedFixingRailRawMaterial },
      {name:'Concealed Fixing Cover', qty: concealedFixingCoverRawMaterial },
      {name:'Channel Infill Hollow', qty: channelInfillHollowRawMaterial },
      {name:'Adjustable Louvre Handle', qty: adjustableLouvreHandleRawMaterial },
      {name:'Adjustable Louvre Bracket Pair', qty: adjustableLouvreBracketQuantity },
      {name:'Screw', qty: screwPackQuantity }
    ]
    if (postRawMaterial > 0) {
      materialResults.splice(2, 0,
        {name:'Post', qty: postRawMaterial }
      );
    }
    if (postCapQuantity > 0) {
      materialResults.push(
        {name:'Post Cap', qty: postCapQuantity }
      );
    }
    materialResults.details = panelDetails;

    return materialResults;
  },

  calculateHorizontalGate: function (input) {
    const gateWidth = input.panelWidth;
    const gateHeight = input.panelHeight;
    const gateCount = input.panelCount;
    const gateOption = input.gateOption;
    const louvreStyle = input.gap;
    const gateLeafCount =
      gateOption === 'double_gate'
        ? gateCount * 2
        : gateCount;
    const singleGateLeafWidth = gateWidth / gateLeafCount;

    //Louvre
    const louvrePieces = [];
    const louvreRows = Math.floor(gateHeight / 50);
    for (let i = 0; i < louvreRows * gateLeafCount; i++) {
      louvrePieces.push(singleGateLeafWidth);
    }
    const louvreRawMaterial = window.CutOptimizer.optimize(louvrePieces, 5800);
    //Gate Frame
    const gateFramePieces = [];
    for (let i = 0; i < gateLeafCount; i++) {
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(singleGateLeafWidth);
      gateFramePieces.push(singleGateLeafWidth);
    }
    const gateFrameRawMaterial = window.CutOptimizer.optimize(gateFramePieces, 5800);
    //Concealed Fixing Cover
    const concealedFixingCoverPieces = [];
    for (let i = 0; i < gateLeafCount; i++) {
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
    }
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //Gate Frame Corner
    const gateFrameCornerQuantity = gateLeafCount * 4; 
    //Post 
    const postPieces = [];
    const postQuantity = gateCount * 2;
    for (let i = 0; i < postQuantity; i++) {
      postPieces.push(gateHeight);
    }
    const postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    //Post Cap
    const postCapQuantity = postQuantity;
    //Louvre Bracket Pair
    const louvreBracketPairQuantity = louvreRows * gateLeafCount;
    //Screw
    const screwLouvreUsableHeight = gateHeight - 130;
    const screwLouvreRows = Math.floor(screwLouvreUsableHeight / 50);
    const gateWidthFixingPoints = Math.floor(singleGateLeafWidth /50);
    let screwQuantity = 0;
    if (gateOption === 'no_post' || gateOption === 'single_gate') {
      screwQuantity = ((screwLouvreRows + 2) * 2) + (gateWidthFixingPoints * 2);
    }
    if (gateOption === 'double_gate') {
      screwQuantity = ((screwLouvreRows + 2) * 4) + (gateWidthFixingPoints * 4);
    }
    screwQuantity *= gateCount;
    const screwPackQuantity = Math.ceil(screwQuantity / 100);
    //Breakdown Detail
    const panelDetails = [];
    const gatePanel = {
      width: gateWidth / gateCount,
      height: gateHeight,
      quantity: gateCount
    };
    const gateLeafQuantityPerGate = gateOption === 'double_gate'
      ? 2
      : 1;
    const louvreQuantityPerGate = louvreRows * gateLeafQuantityPerGate;
    const gateDetail = 
      window.FencingDetailBuilder.createHorizontalLouvreGate(
        gatePanel,
        louvreStyle,
        louvreQuantityPerGate,
        singleGateLeafWidth,
        gateLeafQuantityPerGate,
        screwQuantity
      );
    gateDetail.detailName = 'Gate';
    gateDetail.detailUnit = 'gate';
    panelDetails.push(gateDetail);

    const materialResults = [
      {name:'Louvre', qty: louvreRawMaterial },
      {name:'Gate Frame', qty: gateFrameRawMaterial },
      {name:'Concealed Fixing Cover', qty: concealedFixingCoverRawMaterial },
      {name:'Louvre Bracket Pair', qty: louvreBracketPairQuantity },
      {name:'Gate Frame Corner', qty: gateFrameCornerQuantity },
      {name:'Screw', qty: screwPackQuantity}
    ];
     if(gateOption === 'single_gate'){
        materialResults.push(
          {name:'Post', qty: postRawMaterial },
          {name:'Post Cap', qty: postCapQuantity }
        );
      }
      if(gateOption === 'double_gate'){
        materialResults.push(
          {name:'Post', qty: postRawMaterial },
          {name:'Post Cap', qty: postCapQuantity }
        );
      }
     materialResults.details = panelDetails;

     return materialResults;
  },

  calculateVerticalGate: function (input) {
    const gateWidth = input.panelWidth;
    const gateHeight = input.panelHeight;
    const gateCount = input.panelCount;
    const gateOption = input.gateOption;
    const louvreStyle = input.gap;

    const gateLeafCount = 
      gateOption === 'double_gate'
        ? gateCount * 2
        : gateCount;
    const singleGateLeafWidth = gateWidth / gateLeafCount;

    //Louvre
    const louvrePieces = [];
    const louvreUsableWidth = singleGateLeafWidth - (65 * 2);
    const louvreColumns = Math.floor(louvreUsableWidth / 50);
    for (let i = 0; i < louvreColumns * gateLeafCount; i++) {
      louvrePieces.push(gateHeight);
    }
    const louvreRawMaterial = window.CutOptimizer.optimize(louvrePieces, 5800);
    //GateFrame
    const gateFramePieces = [];
    for (let i =0; i < gateLeafCount; i++) {
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(singleGateLeafWidth);
      gateFramePieces.push(singleGateLeafWidth);
    }
    const gateFrameRawMaterial = window.CutOptimizer.optimize(gateFramePieces, 5800);
    //Concealed Fixing Cover
    const concealedFixingCoverPieces = [];
    for (let i = 0; i < gateLeafCount; i++) {
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
    }
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //Gate Frame Corner
    const gateFrameCornerQuantity = gateLeafCount * 4;
    //Post
    const postPieces = [];
    const postQuantity = gateCount * 2;
    for (let i = 0; i < postQuantity; i++) {
      postPieces.push(gateHeight);
    }
    const postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    //Post Cap
    const postCapQuantity = postQuantity;
    //Louvre Bracket Pair
    const louvreBracketPairQuantity = louvreColumns * 2 * gateLeafCount;
    //Screw
    const gateHeightFixingPoints = Math.floor(gateHeight / 50);
    let screwQuantity = 0;
    if (gateOption === 'no_post' || gateOption === 'single_gate') {
      screwQuantity = ((louvreColumns + 2) * 2) + (gateHeightFixingPoints * 2);
    }
    if (gateOption === 'double_gate') {
      screwQuantity = ((louvreColumns + 2) * 4) + (gateHeightFixingPoints * 4);
    }
    screwQuantity *= gateCount;
    const screwPackQuantity = Math.ceil(screwQuantity / 100);
    //Breakdown Detail
    const panelDetails = [];
    const gatePanel = {
      width: gateWidth / gateCount,
      height: gateHeight,
      quantity: gateCount
    };
    const gateLeafQuantityPerGate = gateOption === 'double_gate'
      ? 2
      : 1;
    const louvreQuantityPerGate = louvreColumns * gateLeafQuantityPerGate;
    const gateDetail = 
      window.FencingDetailBuilder.createVerticalLouvreGate(
        gatePanel,
        louvreStyle,
        louvreQuantityPerGate,
        gateHeight,
        singleGateLeafWidth,
        gateLeafQuantityPerGate,
        screwQuantity
      );
    gateDetail.detailName = 'Gate';
    gateDetail.detailUnit = 'gate';

    panelDetails.push(gateDetail);

    const materialResults = [
      { name: 'Louvre', qty: louvreRawMaterial },
      { name: 'Gate Frame', qty: gateFrameRawMaterial },
      { name: 'Concealed Fixing Cover', qty: concealedFixingCoverRawMaterial },
      { name: 'Louvre Bracket Pair', qty: louvreBracketPairQuantity },
      { name: 'Gate Frame Corner', qty: gateFrameCornerQuantity },
      {name:'Screw', qty: screwPackQuantity}
      
    ];
     if(gateOption === 'single_gate'){
        materialResults.push(
          {name:'Post', qty: postRawMaterial },
          {name:'Post Cap', qty: postCapQuantity }
        );
      }
      if(gateOption === 'double_gate'){
        materialResults.push(
          {name:'Post', qty: postRawMaterial },
          {name:'Post Cap', qty: postCapQuantity }
        );
      }
    materialResults.details = panelDetails;
    
    return materialResults;   
  }
};